import React, {useEffect, useRef, useState} from 'react';
import PropTypes                            from 'prop-types';
import Translations                         from '../../utils/Translations';

let _touchStart = 0;

function onOutsideClick(ref, setShowSorter) {
    useEffect(() => {
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                setShowSorter(false);
            }
        }

        document.addEventListener("click", handleClickOutside);
        return () => {
            document.removeEventListener("click", handleClickOutside);
        };
    }, [ref]);
}

function onTouchStart(e) {
    _touchStart = e.changedTouches[0].screenY;
}

function ExtendedSorter({onSortChange, defaultSort, sorts}) {
    const [showSorter, setShowSorter] = useState(false);
    const [sort, setSort]             = useState(defaultSort);
    const wrapperRef                  = useRef(null);
    onOutsideClick(wrapperRef, setShowSorter);

    function onTouchMove(e) {
        if (_touchStart + 90 < e.changedTouches[0].screenY) {
            setShowSorter(false);
            _touchStart = 0;
        }
    }

    function beforeSetSort(sort) {
        setSort(sort);
        onSortChange(sort);
        setShowSorter(false);
    }

    function onClickSort(item) {
        beforeSetSort(item.sort);
    }

    function onIconClick(e, item) {
        e.preventDefault();
        e.stopPropagation();
        item.onIconClick && item.onIconClick({beforeSetSort});
    }

    return <div className="extended-sorter__wrapper" ref={wrapperRef}>
        <div className='extended-sorter--desktop'>
            {Translations.get('SortBy')}:
            <button className="extended-sorter__chooser" onClick={() => setShowSorter(!showSorter)}>
                {sorts.find(item => item.sort === sort).text}
                <i className={'icon ' + (showSorter ? '-icon-single-arrow-up-line' : ' -icon-single-arrow-down-line')} />
            </button>
        </div>
        <div className={'extended-sorter--mobile' + (showSorter ? ' extended-sorter--mobile--active' : '')}
             onClick={() => setShowSorter(!showSorter)}>
            <i className='icon icon -icon-sort-line' />
        </div>

        <div className={'extended-sorter__popup' + (showSorter ? ' extended-sorter__popup--show' : '')}
             onTouchStart={onTouchStart}
             onTouchMove={onTouchMove}>
            <div className='extended-sorter__popup__line'></div>
            <div className='extended-sorter__popup__headline'>{Translations.get('SortBy')}</div>
            {sorts.map((item, index) => (
                    <button tabIndex={showSorter ? 0 : -1} className={'extended-sorter__popup__item' + (index === 0 ? ' extended-sorter__popup__item--first' : '')}
                         onClick={() => onClickSort(item)}
                         key={index}>
                        <div className='extended-sorter__popup__item-text'>{item.text}
                            {item.subText && <span>{item.subText}</span>}
                        </div>
                        {item.icon && <button tabIndex={showSorter ? 0 : -1} className='extended-sorter__popup__item-button__wrapper' onClick={(e) => onIconClick(e, item)}>
                            <i className={'extended-sorter__popup__item-icon icon ' + item.icon }  />
                        </button>}
                        {sort === item.sort ? <i className='icon -icon-success-rounded-full extended-sorter__popup__item-icon extended-sorter__popup__item-icon--success' /> : <div className='extended-sorter__popup__item-icon__placeholder'></div> }
                    </button>
            ))}
        </div>

    </div>;
}

ExtendedSorter.propTypes = {
    onSortChange: PropTypes.func,
    defaultSort:  PropTypes.string,
    sorts:        PropTypes.array,
};

ExtendedSorter.defaultProps = {
    onSortChange: null,
    defaultSort:  '',
    sorts:        [],
};

export default ExtendedSorter;
